<template>
  <router-view />
</template>

<script>
export default {
  name: "LandingTemplate"
};
</script>

<style scoped></style>
